import { render, staticRenderFns } from "./FeedbackTemplates.vue?vue&type=template&id=08e3beb6"
import script from "./FeedbackTemplates.vue?vue&type=script&lang=js"
export * from "./FeedbackTemplates.vue?vue&type=script&lang=js"
import style0 from "./FeedbackTemplates.vue?vue&type=style&index=0&id=08e3beb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports